import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {SharedModule} from "../shared.module";
import {YzAiAssistantComponent} from './yz-ai-assistant/yz-ai-assistant.component';

const COMPONENTS = [
  YzAiAssistantComponent
];

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [...COMPONENTS],
  entryComponents: [...COMPONENTS],
  imports: [SharedModule],
  exports: [...COMPONENTS]
})
export class AiAssistantModule {
}
